import React, { useEffect, useState } from 'react';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';

// 컴포넌트들 가져오기
import SelectMode from '../components/SelectMode';
import CountDown from '../components/CountDown';
import InterviewPage from '../components/InterviewPage';
import ResultPage from '../components/ResultPage';
import LuckyMessage from '../components/LuckyMessage';

// 질문 데이터
const defaultQuestions = [
  '자기소개 부탁드립니다.',
  '지원자께서는 우리 회사 지원 동기를 말씀해주세요.',
  '본인의 장단점을 말씀해주세요.',
  '지원자께서는 지원하신 직무가 어떤일을 하는지 알고 계신가요?',
  '우리회사에 대해 알고 있는대로 말씀해주세요.',
  '지원자께서는 지원하는 직무를 위해서 어떤 노력을 하셨나요?',
  '지원자께서는 입사후에 하고 싶은 것이 있다면 말씀해주세요.',
  '지원자께서는 어떤 상황일때 스트레스를 받으시나요? 그리고 어떻게 푸시나요?',
  '많은 지원자들 가운데 왜 본인을 뽑아야 한다고 생각하시나요?',
  '마지막으로 하고 싶은 말이 있다면 말씀해주세요.'
];

const deepQuestions = [
  '이제까지 살아오면서 가장 어려웠던(힘들었던) 경험은 무엇이었나요?',
  '야근이나 주말출근에 대해 어떻게 생각하나요?',
  '상사와 의견이 다를때는 어떻게 하실건가요?',
  '다른 사람을 배려하고 도움을 제공하여 긍정적인 영향을 주었던 경험에 대해서 말씀해 주세요',
  '직업선택시 본인이 가장 중요하게 생각하는것은 무엇인가요?',
  '상사가 부당한 업무를 지시했을때는 어떻게 행동하실건가요?',
  '5년 후에는 어떤모습일지 생각해본적 있나요?',
  '개인의 전문성 향상과 팀의 협업 능력 향상 중에서 더 우선시해야 한다고 생각하는 것과 이유를 말씀해주세요.',
  '지원자께서는 어떤사람과 일하고 싶지 않은가요? 그 사람과 일하게 된다면 어떻게 하실건가요?',
  '주변사람들은 지원자를 어떻게 평가하나요?'
];

const situationQuestions = [
  '고객이 무리한 요구를 하며 화를 내고 있습니다. 어떻게 상황을 해결하시겠습니까?',
  '팀원과 의견이 다를 때 직접 대화로 해결하는 것과 팀장이나 제3자를 통해 조율하는 것 중에서 더 효과적이라고 생각하는 것과 이유를 말씀해주세요.',
  '동료가 실수를 했을 때, 아무 일 없었다는 듯이 넘어가는 것과 다소 분위기가 어색해질지라도 실수를 언급하는 것 중에서 더 필요하다고 생각하는 것과 이유를 말씀해주세요.',
  '예산이 절반으로 줄어든 상황에서 프로젝트를 완료해야 합니다. 어떤 전략을 사용하시겠습니까?.',
  '업무를 배울 때 동료나 선배가 귀찮게 여길지라도 모르는 것은 바로바로 질문하는 것과 일단 시간이 걸려도 최대한 알아본 이후에 질문하는 것 중에서 더 좋은 자세라고 생각하는 것과 이유를 말씀해주세요.',
  '나의 능력을 인정받을 수는 있지만 성장에 도움이 되지 않는 프로젝트와 성장에는 큰 도움이 되지만 나의 존재가 크게 드러나지 않는 프로젝트 중에서 더 원하는 것과 이유를 말씀해주세요.',
  '상사가 부당하다고 생각되는 업무지시를 했습니다. 어떻게 행동하시겠습니까?',
  '정해진 마감일을 지키지 못 하더라도 완벽하게 일을 하는 것과 정해진 마감일은 지킬 수 있지만 미완성으로 일을 하는 것 중에서 더 중요하다고 생각하는 것과 이유를 말씀해주세요.',
  '야근이 계속되어 개인시간이 없어진 상황입니다. 어떻게 해결하시겠습니까?',
  '즉흥적인 친구, 계획적인 친구와 함께 여행 갔을 때 어떻게 할 것인가요?'
];

// 🆕 입시면접 질문 15개
const admissionQuestions = [
    '1. 자기소개 부탁드립니다.',
    '2. 우리대학을 지원한 이유는 말씀해주세요.',
    '3. 지원하신 학과를 선택한 이유를 말씀해주세요.',
    '4. 고등학교 때 어려움을 겪었던 경험과 극복과정을 말씀해주세요.',
    '5. 본인의 강점과 약점은 무엇이며, 약점은 어떻게 보완하고 계신가요?',
    '6. 입학하신 후 학업계획이 있다면 말씀해주세요.',
    '7. 고등학교 때 가장 기억에 남는 경험이 있다면 말씀해주세요. 학업, 동아리, 봉사활동등 자유롭게 말씀해주세요.',
    '8. 본인이 지원한 전공을 위해서 노력한 부분이 있다면 말씀해주세요.',
    '9. 최근 읽은 책 중 인상 깊었던 책과 그 이유를 말씀해주세요.',
    '10.대학에 입학하면 무엇을 하고 싶나요? 동아리나 공부 등 자유롭게 말씀해주세요.',
    '11. 졸업 후 진로 계획이 있다면 말씀해주세요.',
    '12. 최근 관심 있는 사회 이슈를 말씀해주세요.',
    '13. 본인을 뽑아야 되는 이유를 말씀해주세요.',
    '14. 본인만의 좌우명이나 인생관이 있다면 말씀해주세요.',
    '15. 마지막으로 하고 싶은 말이 있다면 말씀해주세요.'
];

function InterviewApp({ darkMode }) {
  // 🔥 초기 단계를 'selectMode'로 변경 (intro 건너뛰기)
  const [step, setStep] = useState('selectMode');
  const [mode, setMode] = useState('default');
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [feedback, setFeedback] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [jobQuestions, setJobQuestions] = useState({});
  const [selectedJob, setSelectedJob] = useState('');
  const [showLuckyMessage, setShowLuckyMessage] = useState(false);

  const { transcript, resetTranscript, browserSupportsSpeechRecognition } = useSpeechRecognition();

  // 질문 선택
  const getQuestions = () => {
    switch (mode) {
      case 'default': return defaultQuestions;
      case 'deep': return deepQuestions;
      case 'situation': return situationQuestions;
      case 'custom': return jobQuestions[selectedJob] || defaultQuestions;
      case 'admission': return admissionQuestions;
      default: return defaultQuestions;
    }
  };

  // 직무별 질문 로딩
  useEffect(() => {
    fetch('/questions_full.json')
      .then(res => res.json())
      .then(data => setJobQuestions(data))
      .catch(err => console.error('질문 파일 로딩 실패:', err));
  }, []);

  // 🆕 직무선택 화면으로 전환될 때 스크롤 조정
useEffect(() => {
  if (step === 'selectJob') {
    setTimeout(() => {
      window.scrollTo({
        top: 200, // 200px 정도 아래로
        behavior: 'smooth'
      });
    }, 100);
  }
}, [step]);

  // 음성인식 지원 확인
  if (!browserSupportsSpeechRecognition) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-red-50">
        <div className="text-center p-8 bg-white rounded-2xl shadow-lg">
          <div className="text-6xl mb-4">😞</div>
          <h2 className="text-2xl font-bold text-red-600 mb-2">음성인식 지원 안됨</h2>
          <p className="text-gray-600">Chrome, Edge, Safari 최신 버전을 사용해주세요.</p>
        </div>
      </div>
    );
  }

  // 모드 선택 핸들러
  const handleModeSelect = (selectedMode) => {
    setMode(selectedMode);
    
    if (selectedMode === 'lucky') {
      setShowLuckyMessage(true);
      return;
    }
    
    if (selectedMode === 'custom') {
      setStep('selectJob');
    } else {
      setStep('countdown');
    }
  };

  // 면접 시작 핸들러
  const handleInterviewStart = () => {
    if (!SpeechRecognition.browserSupportsSpeechRecognition()) {
      alert('음성 인식을 지원하지 않는 브라우저입니다.');
      return;
    }

    const shouldProceed = window.confirm(
      '🎤 마이크 권한이 필요합니다!\n\n' +
      '• 브라우저에서 마이크 권한을 허용해주세요\n' +
      '• 조용한 환경에서 연습하시면 더 좋아요\n' +
      '• 준비되셨으면 확인을 눌러주세요!'
    );

    if (!shouldProceed) {
      handleHome();
      return;
    }

    setStep('interview');
    setCurrentQuestionIndex(0);
    setAnswers([]);
    resetTranscript();

    try {
      SpeechRecognition.startListening({ continuous: false });
      setTimeout(() => {
        SpeechRecognition.stopListening();
      }, 1000);
    } catch (error) {
      console.log('음성 인식 초기화 오류:', error);
    }
  };

  // 다음 질문 핸들러
  const handleNextQuestion = (currentAnswer) => {
    const newAnswers = [...answers, currentAnswer || transcript];
    setAnswers(newAnswers);
    
    const questions = getQuestions();
    if (currentQuestionIndex < questions.length - 1) {
      setCurrentQuestionIndex(prev => prev + 1);
      resetTranscript();
    } else {
      setStep('done');
      analyzeFeedback(newAnswers);
    }
  };

  // 평가 시스템
  const analyzeFeedback = (finalAnswers) => {
    setIsLoading(true);
    
    setTimeout(() => {
      const questions = getQuestions();
      const totalQuestions = questions.length;
      const answeredQuestions = finalAnswers.filter(answer => answer.trim().length > 0).length;
      const fullText = finalAnswers.join(' ');
      const wordCount = fullText.trim().split(/\s+/).length;
      
      if (answeredQuestions === 0) {
        const noAnswerFeedback = generateNoAnswerFeedback();
        setFeedback({
          summary: noAnswerFeedback,
          details: {},
          stats: {
            totalQuestions,
            answeredQuestions: 0,
            wordCount: 0,
            avgWordsPerAnswer: 0,
            estimatedTime: "0분 0초",
            wordsPerMinute: 0
          }
        });
        setIsLoading(false);
        return;
      }
      
      const avgWordsPerAnswer = Math.round(wordCount / answeredQuestions);

      const participationRate = answeredQuestions / totalQuestions;
      const participationLevel = 
        participationRate >= 0.9 ? "적극적 참여 💪" : 
        participationRate >= 0.7 ? "양호한 참여 👍" : "더 도전해보세요 😊";

      const isLongAnswerType = (question) => {
        const longKeywords = ['자기소개', '지원동기', '지원한 이유', '경험', '장점', '단점', '성공', '실패', '어려움', '극복'];
        return longKeywords.some(keyword => question.includes(keyword));
      };

      const answerEvaluations = finalAnswers.map((answer, index) => {
        if (answer.trim().length === 0) return { wordCount: 0, evaluation: "답변 없음" };
        
        const words = answer.trim().split(/\s+/).length;
        const question = questions[index];
        const isLong = isLongAnswerType(question);
        
        let evaluation;
        if (isLong) {
          if (words < 45) evaluation = "더 자세히 📝";
          else if (words <= 90) evaluation = "적절한 분량 👍";
          else evaluation = "더 간결하게 ✂️";
        } else {
          if (words < 35) evaluation = "더 자세히 📝";
          else if (words <= 60) evaluation = "적절한 분량 👍";
          else evaluation = "더 간결하게 ✂️";
        }
        
        return { wordCount: words, evaluation, isLong };
      });

      const goodAnswers = answerEvaluations.filter(item => item.evaluation === "적절한 분량 👍").length;
      const lengthLevel = 
        goodAnswers >= answeredQuestions * 0.8 ? "적절한 분량 👍" :
        goodAnswers >= answeredQuestions * 0.5 ? "대체로 적절 👌" : "분량 조절 필요 📝";

      const hesitationWords = /음|어|그|아|임|흠|으음|그러니까|어떻게|글쎄|뭔가|아무튼|그냥|일단/g;
      const hesitations = (fullText.match(hesitationWords) || []).length;
      
      let hesitationLevel;
      if (avgWordsPerAnswer < 20) {
        hesitationLevel = "더 길게 말해보세요 📝";
      } else if (avgWordsPerAnswer >= 20 && hesitations <= 8) {
        hesitationLevel = "유창한 답변 💫";
      } else if (avgWordsPerAnswer >= 20 && hesitations <= 15) {
        hesitationLevel = "자연스러운 답변 👌";
      } else {
        hesitationLevel = "천천히 생각하고 말해보세요 😌";
      }

      const sentences = fullText.split(/[.!?]/).filter(s => s.trim().length > 0);
      const avgSentences = Math.round(sentences.length / answeredQuestions);
      const hasConnectors = (fullText.match(/(그래서|따라서|또한|하지만|그러나|그런데|왜냐하면|첫째|둘째)/g) || []).length;
      const structureLevel = 
        avgSentences >= 3 && hasConnectors >= 2 ? "체계적인 답변 🏗️" :
        avgSentences >= 2 ? "적당한 구조 👍" : "더 구체적으로 📝";

      const words = fullText.split(/\s+/);
      const wordCounts = {};
      words.forEach(word => {
        if (word.length > 1) {
          wordCounts[word] = (wordCounts[word] || 0) + 1;
        }
      });
      const maxRepeat = Math.max(...Object.values(wordCounts));
      const diversityLevel = 
        maxRepeat <= 2 ? "다양한 표현 🌈" :
        maxRepeat <= 3 ? "자연스러운 표현 👍" : "표현을 다양하게 해보세요 🔄";

      const positiveWords = (fullText.match(/(좋다|잘|성공|성장|발전|향상|개선|열정|자신감|긍정|적극|노력|도전|기여)/g) || []).length;
      const negativeWords = (fullText.match(/(안|못|실패|어려워|힘들어|부족|문제|걱정|불안)/g) || []).length;
      const toneLevel = 
        positiveWords > negativeWords ? "긍정적인 답변 ✨" :
        positiveWords === negativeWords ? "균형잡힌 답변 ⚖️" : "더 긍정적으로 🌟";

      const specificWords = (fullText.match(/(\d+|대학교|회사|프로젝트|년|개월|명|번째|퍼센트|시간|일|주|달)/g) || []).length;
      const specificityLevel = 
        specificWords >= answeredQuestions * 2 ? "구체적인 답변 🎯" :
        specificWords >= answeredQuestions ? "적당한 구체성 👍" : "더 구체적인 예시를 📋";

      const estimatedTime = wordCount / 2;
      const wordsPerMinute = Math.round((wordCount / estimatedTime) * 60);
      const speedLevel = 
        wordsPerMinute >= 80 && wordsPerMinute <= 150 ? "적절한 속도 🎙️" :
        wordsPerMinute < 80 ? "조금 더 빠르게 🚀" : "조금 더 천천히 🐌";

      const informalEndings = (fullText.match(/\s+요[\s\.\?!]*$/gm) || []).length;
      const endingLevel = 
        informalEndings <= 1 ? "적절한 마무리 👍" :
        informalEndings <= 3 ? "마무리 개선 필요 📢" : "정중한 어미 연습 🎭";

      const encouragingFeedback = generateNewEncouragingFeedback({
        mode,
        totalQuestions,
        answeredQuestions,
        participationLevel,
        lengthLevel,
        hesitationLevel,
        structureLevel,
        diversityLevel,
        toneLevel,
        specificityLevel,
        speedLevel,
        endingLevel,
        avgWordsPerAnswer,
        wordsPerMinute,
        estimatedTime
      });

      setFeedback({
        summary: encouragingFeedback,
        details: {
          participationLevel,
          lengthLevel,
          hesitationLevel,
          structureLevel,
          diversityLevel,
          toneLevel,
          specificityLevel,
          speedLevel,
          endingLevel
        },
        stats: {
          totalQuestions,
          answeredQuestions,
          wordCount,
          avgWordsPerAnswer,
          estimatedTime: `${Math.floor(estimatedTime / 60)}분 ${Math.round(estimatedTime % 60)}초`,
          wordsPerMinute
        }
      });
      
      setIsLoading(false);
    }, 2000);
  };

  const generateNoAnswerFeedback = () => {
    return `🤗 면접 연습에 참여해주셔서 고마워요!

😊 아직 답변을 하지 않으셨네요! 
면접 연습은 실제로 말해보는 것이 가장 중요해요!

🎯 다음번에는 이렇게 해보세요:
- 조용한 곳에서 연습해보세요 🤫
- 처음에는 짧게라도 말해보세요 💬
- 완벽하지 않아도 괜찮아요! 연습이 목적이에요 ✨

🔄 계속 도전해보세요!
📚 같은 유형을 다시 연습하거나, 🏠 홈으로 가서 새로운 유형에 도전해보세요!

💪 면접은 연습할수록 늘어요! 
다음번에는 꼭 목소리로 답변해보세요! 화이팅! 🔥`;
  };

  const generateNewEncouragingFeedback = (stats) => {
    const modeNames = {
      'default': '기본질문',
      'deep': '심화질문', 
      'situation': '상황별',
      'custom': '직무별',
      'admission': '입시면접'
    };

    const encouragingStarts = [
      `🎉 ${modeNames[stats.mode] || ''}면접 연습 완료! 정말 수고하셨어요!`,
      `💪 오늘도 성실하게 연습해주셨네요! 한 걸음 더 성장하신 당신이 자랑스러워요!`,
      `✨ 꾸준한 연습이 실력을 만들어요! 면접 연습 완료, 정말 대단해요!`,
      `🌟 ${modeNames[stats.mode] || ''}면접 도전! 실전이 기대되는 멋진 연습이었어요!`
    ];
    
    const randomStart = encouragingStarts[Math.floor(Math.random() * encouragingStarts.length)];
    let feedback = `${randomStart}\n\n`;

    if (stats.answeredQuestions === stats.totalQuestions) {
      feedback += `🏆 ${stats.totalQuestions}개 질문 모두 완주! 끝까지 포기하지 않는 성실함이 정말 인상적이에요!\n`;
    } else {
      feedback += `💫 ${stats.answeredQuestions}개 질문에 도전! 면접 연습에 참여해주셔서 고마워요!\n`;
    }

    const specificPraises = [];
    
    if (stats.avgWordsPerAnswer >= 40) {
      const detailPraises = [
        "📝 충분히 자세하게 답변해주셔서 좋았어요! 내용이 풍부하네요!",
        "💬 답변이 구체적이고 알찬 것 같아요! 정말 좋아요!",
        "📖 내용이 많아서 듣는 재미가 있었어요! 멋져요!",
        "✍️ 자세한 설명으로 이해하기 쉬웠어요! 훌륭해요!"
      ];
      specificPraises.push(detailPraises[Math.floor(Math.random() * detailPraises.length)]);
    }

    if (stats.hesitationLevel.includes('유창')) {
      const fluencyPraises = [
        "🎙️ 또렷하고 자신감 있게 말씀하신 것 같아요! 멋져요!",
        "🗣️ 말하기가 정말 자연스러우시네요! 인상적이에요!",
        "💫 유창하게 말씀하셔서 듣기 좋았어요! 대단해요!",
        "✨ 자신감 있는 목소리가 정말 좋네요! 최고예요!"
      ];
      specificPraises.push(fluencyPraises[Math.floor(Math.random() * fluencyPraises.length)]);
    }

    if (stats.participationLevel.includes('적극적')) {
      const participationPraises = [
        "🔥 적극적인 참여 자세가 정말 보기 좋아요!",
        "💪 끝까지 도전하는 모습이 멋있어요!",
        "🌟 열정적으로 연습하는 모습이 인상적이에요!"
      ];
      specificPraises.push(participationPraises[Math.floor(Math.random() * participationPraises.length)]);
    }

    const shuffledPraises = specificPraises.sort(() => 0.5 - Math.random()).slice(0, 2);
    shuffledPraises.forEach(praise => {
      feedback += praise + "\n";
    });

    feedback += `\n📊 오늘의 연습 결과를 확인해보세요:\n\n`;

    const evaluationItems = [
      { icon: '🎯', label: '참여도', value: stats.participationLevel },
      { icon: '📝', label: '답변 분량', value: stats.lengthLevel },
      { icon: '🗣️', label: '말하기', value: stats.hesitationLevel },
      { icon: '🏗️', label: '답변 구조', value: stats.structureLevel },
      { icon: '🌈', label: '표현 다양성', value: stats.diversityLevel },
      { icon: '💬', label: '답변 어조', value: stats.toneLevel },
      { icon: '🎯', label: '구체성', value: stats.specificityLevel },
      { icon: '🎙️', label: '말속도', value: stats.speedLevel },
      { icon: '🎭', label: '마무리', value: stats.endingLevel }
    ];

    evaluationItems.forEach(item => {
      feedback += `${item.icon} ${item.label}: ${item.value}\n`;
    });

    feedback += `\n📈 연습 통계:\n`;
    feedback += `• 총 답변 시간: ${Math.floor(stats.estimatedTime / 60)}분 ${Math.round(stats.estimatedTime % 60)}초\n`;
    feedback += `• 평균 답변 길이: ${stats.avgWordsPerAnswer}단어\n`;
    feedback += `• 완료한 질문: ${stats.answeredQuestions}개 / ${stats.totalQuestions}개\n`;
    if (stats.wordsPerMinute) {
      feedback += `• 말하기 속도: 분당 ${stats.wordsPerMinute}단어\n`;
    }

    feedback += `\n🚀 다음 연습에서는:\n`;

    const improvements = [];
    
    if (stats.lengthLevel.includes('더 자세히') || stats.lengthLevel.includes('분량 조절')) {
      improvements.push('• 구체적인 경험과 예시를 더 많이 포함시켜보세요! 당신의 이야기가 더 궁금해요! ✨');
    } else if (stats.lengthLevel.includes('더 간결하게')) {
      improvements.push('• 핵심 위주로 간결하게 정리해보세요! 포인트를 명확히 하는 연습을! 🎯');
    }

    if (stats.hesitationLevel.includes('천천히') || stats.hesitationLevel.includes('더 길게')) {
      improvements.push('• 긴장하지 마세요! 천천히 생각하고 충분히 말씀해보세요! 😌');
    }

    if (stats.structureLevel.includes('더 구체적으로')) {
      improvements.push('• 처음-중간-끝 구조로 답변해보세요! 더욱 체계적으로 들릴 거예요! 🏗️');
    }

    if (stats.diversityLevel.includes('다양하게')) {
      improvements.push('• 같은 단어 반복을 줄이고 다양한 표현을 써보세요! 어휘력이 돋보일 거예요! 🌈');
    }

    if (stats.toneLevel.includes('더 긍정적으로')) {
      improvements.push('• 긍정적인 표현을 더 많이 사용해보세요! 밝은 에너지가 느껴질 거예요! ☀️');
    }

    if (stats.specificityLevel.includes('더 구체적인')) {
      improvements.push('• 숫자나 구체적인 예시를 더 포함해보세요! 설득력이 훨씬 높아져요! 📊');
    }

    if (stats.speedLevel.includes('더 빠르게')) {
      improvements.push('• 조금 더 빠르게 말해보세요! 활기찬 느낌을 줄 수 있어요! 🚀');
    } else if (stats.speedLevel.includes('더 천천히')) {
      improvements.push('• 조금 더 천천히 말해보세요! 안정감 있게 들릴 거예요! 🐌');
    }

    if (stats.endingLevel.includes('개선 필요') || stats.endingLevel.includes('연습')) {
      improvements.push('• "~습니다" 같은 정중한 어미로 마무리해보세요! 더욱 전문적으로 들려요! 🎭');
    }

    if (improvements.length === 0) {
      feedback += `• 완벽해요! 이대로 계속 연습하시면 어떤 면접도 문제없어요! 🌟\n`;
      feedback += `• 자신감을 가지고 당당하게 말씀하세요! 당신은 이미 충분히 준비되었어요! 💪\n`;
    } else {
      improvements.slice(0, 3).forEach(improvement => {
        feedback += improvement + '\n';
      });
    }

    feedback += `• 개인적인 경험과 진정성을 더 많이 담아보세요! 진짜 당신의 모습을 보여주세요! 💝\n`;
    feedback += `• 꾸준한 연습이 가장 중요해요! 오늘도 한 걸음 전진했어요! 🔥\n`;

    feedback += `\n🔄 계속 도전해보세요!\n`;
    
    const nextRecommendations = {
      'default': '🎯 기본기가 탄탄하시네요! 이제 심화질문에 도전해보세요!',
      'deep': '💪 심화질문까지 완료! 상황질문으로 실전 감각을 키워보세요!', 
      'situation': '🔥 상황대응 능력도 훌륭해요! 직무별 질문으로 전문성을 보여주세요!',
      'custom': '🌟 모든 유형을 마스터하셨네요! 계속 반복 연습으로 완벽하게!',
      'admission': '🎓 입시면접 준비 완벽해요! 자신감을 가지고 실전에 임하세요!'
    };

    feedback += nextRecommendations[stats.mode] || '다른 유형도 도전해보세요!';
    feedback += `\n\n📚 같은 유형을 다시 연습하거나, 🏠 홈으로 가서 새로운 유형에 도전해보세요!\n`;

    const finalEncouragements = [
      `✨ 당신의 노력이 분명 좋은 결과로 이어질 거예요! 꿈꾸던 곳에서 꼭 좋은 소식 들려주세요! 화이팅! 🔥`,
      `💫 실전 면접에서도 오늘처럼 자신감 있게 하시면 완벽해요! 당신을 응원합니다! 💪`,
      `🌟 계속 이렇게 연습하시면 어떤 면접관도 당신의 매력에 빠질 거예요! 최고예요! ✨`,
      `🎯 면접은 연습할수록 자신감이 생겨요! 당신은 분명 원하는 곳에 합격할 수 있어요! 응원할게요! 🚀`
    ];
    
    const randomEnd = finalEncouragements[Math.floor(Math.random() * finalEncouragements.length)];
    feedback += `\n${randomEnd}`;
    
    return feedback;
  };

  const handleRestart = () => {
    setStep('countdown');
    setCurrentQuestionIndex(0);
    setAnswers([]);
    setFeedback(null);
    resetTranscript();
  };

  const handleHome = () => {
    window.speechSynthesis.cancel();
    SpeechRecognition.stopListening();
    
    setStep('selectMode');
    setMode('default');
    setCurrentQuestionIndex(0);
    setAnswers([]);
    setFeedback(null);
    setSelectedJob('');
    resetTranscript();
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6">
      {/* 🆕 행운응원 팝업 */}
      {showLuckyMessage && (
        <LuckyMessage 
          onClose={() => setShowLuckyMessage(false)}
          darkMode={darkMode}
        />
      )}

      {/* 페이지 렌더링 - intro 단계 제거 */}
      {step === 'selectMode' && (
        <SelectMode 
          onModeSelect={handleModeSelect}
          onBack={() => setStep('selectMode')}
          darkMode={darkMode}
        />
      )}

      {step === 'selectJob' && (
        <div className={`p-8 rounded-2xl shadow-xl max-w-xl w-full text-center space-y-4 ${darkMode ? 'bg-gray-800 text-white' : 'bg-white text-gray-800'}`}>
          <h2 className="text-2xl font-bold mb-6">💼 희망 직무를 선택하세요</h2>
          <select 
            onChange={(e) => setSelectedJob(e.target.value)} 
            className="w-full p-3 border rounded-lg text-lg text-gray-800"
            value={selectedJob}
          >
            <option value="">-- 직무 선택 --</option>
            {Object.keys(jobQuestions).map(job => (
              <option key={job} value={job}>{job}</option>
            ))}
          </select>
          <div className="flex space-x-4">
            <button 
              onClick={() => setStep('selectMode')}
              className="flex-1 px-6 py-3 rounded-xl bg-gray-500 text-white font-semibold hover:bg-gray-600 transition-all duration-300"
            >
              ← 이전으로
            </button>
            <button 
              disabled={!selectedJob} 
              onClick={() => setStep('countdown')} 
              className="flex-1 px-6 py-3 rounded-xl bg-green-500 text-white font-semibold hover:bg-green-600 disabled:bg-gray-400 disabled:cursor-not-allowed transition-all duration-300"
            >
              면접 시작! 🚀
            </button>
          </div>
        </div>
      )}

      {step === 'countdown' && (
        <CountDown 
          mode={mode}
          onStart={handleInterviewStart}
          darkMode={darkMode}
        />
      )}

      {step === 'interview' && (
        <InterviewPage 
          questions={getQuestions()}
          currentIndex={currentQuestionIndex}
          mode={mode}
          selectedJob={selectedJob}
          onNext={handleNextQuestion}
          darkMode={darkMode}
        />
      )}

      {step === 'done' && (
        <ResultPage 
          feedback={feedback}
          isLoading={isLoading}
          onRestart={handleRestart}
          onHome={handleHome}
          darkMode={darkMode}
        />
      )}
    </div>
  );
}

export default InterviewApp;